import { convertMomentFormat, formatDate } from 'lib/helpers/dateUtils';

import useUserPreferencesState from 'components/practice/UserPreferences/hooks/useUserPreferencesState';

import useTimezone from './useTimezone';

const useDateTimeFormat = () => {
  const timezone = useTimezone();

  const { generalPreferences } = useUserPreferencesState(['user_general']);
  const dateFormat = generalPreferences?.dateFormat || 'MM/DD/YYYY';
  const timeFormat = generalPreferences?.timeFormat || 'HH:mm';

  return {
    formatDate: (date) => formatDate(date, timezone, convertMomentFormat(dateFormat)),
    formatTime: (date) => formatDate(date, timezone, timeFormat)
  };
};

export default useDateTimeFormat;
